import { IDependenciesRecord } from '../../../ModuleStore/interfaces/IDependencies';

export const COMMON_BOARD_REQUIRED_MODULES: IDependenciesRecord = {
    // Note: [🏈] We want all modules to be in some cases uninstallable
};
